<div class="controls">
  <div class="container">
    <div class="filters">
      <mat-form-field>
        <mat-label>Entity</mat-label>
        <input (keyup)="applyFiltersOnChange($event)" matInput [formControl]="formFilters.controls.entity_name" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Doc Group</mat-label>
        <mat-select [formControl]="formFilters.controls.doc_group_id" multiple>
          <mat-option>&mdash;</mat-option>
          @for (docGroup of documentsTrackerService.docGroups$ | async; track docGroup) {
            <mat-option
              [value]="docGroup.id"
              >{{ docGroup.name }}</mat-option
              >
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Asset Manager</mat-label>
          <input
            matInput
            [formControl]="formFilters.controls.asset_manager_name" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Auditor</mat-label>
          <input matInput [formControl]="formFilters.controls.auditor_name" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Document Type</mat-label>
          <mat-select [formControl]="formFilters.controls.doc_type_id" multiple>
            <mat-option>&mdash;</mat-option>
            @for (docType of documentsTrackerService.docTypes$ | async; track docType) {
              <mat-option
                [value]="docType.id"
                >{{ docType.name }}</mat-option
                >
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Document Subtype</mat-label>
            <mat-select [formControl]="formFilters.controls.current_doc_subtype_id" multiple>
              <mat-option>&mdash;</mat-option>
              @for (subType of documentsTrackerService.docSubtypes$ | async; track subType) {
                <mat-option
                  [value]="subType.id"
                  >{{ subType.name }}</mat-option
                  >
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Document Status</mat-label>
              <mat-select [formControl]="formFilters.controls.current_doc_status_id" multiple>
                <mat-option>&mdash;</mat-option>
                @for (status of documentsTrackerService.docStatuses$ | async; track status) {
                  <mat-option
                    [value]="status.id"
                    >{{ status.name }}</mat-option
                    >
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="filters">
              <mat-form-field>
                <mat-label>Period Dates</mat-label>
                <mat-date-range-input [rangePicker]="periodPicker">
                  <input
                    (keyup)="applyFiltersOnChange($event)"
                    matStartDate
                    placeholder="Start Date"
                    [formControl]="formFilters.controls.doc_date_from" />
                  <input
                    (keyup)="applyFiltersOnChange($event)"
                    matEndDate
                    placeholder="End Date"
                    [formControl]="formFilters.controls.doc_date_to" />
                </mat-date-range-input>
                <mat-hint>MM/DD/YYYY - MM/DD/YYYY</mat-hint>
                <mat-datepicker-toggle
                  [for]="periodPicker"
                matIconSuffix></mat-datepicker-toggle>
                <mat-date-range-picker #periodPicker></mat-date-range-picker>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Due Dates</mat-label>
                <mat-date-range-input [rangePicker]="duePicker">
                  <input
                    (keyup)="applyFiltersOnChange($event)"
                    matStartDate
                    placeholder="Start Date"
                    [formControl]="formFilters.controls.due_date_from" />
                  <input
                    (keyup)="applyFiltersOnChange($event)"
                    matEndDate
                    placeholder="End Date"
                    [formControl]="formFilters.controls.due_date_to" />
                </mat-date-range-input>
                <mat-hint>MM/DD/YYYY - MM/DD/YYYY</mat-hint>
                <mat-datepicker-toggle
                  [for]="duePicker"
                matIconSuffix></mat-datepicker-toggle>
                <mat-date-range-picker #duePicker></mat-date-range-picker>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Difficulty</mat-label>
                <mat-select
                  [formControl]="formFilters.controls.tax_return_difficult_level_id" multiple>
                  <mat-option>&mdash;</mat-option>
                  @for (
                    difficulty of documentsTrackerService.taxReturnDifficultyLevels$
                    | async
                    ; track
                    difficulty) {
                    <mat-option
                      [value]="difficulty.id"
                      >{{ difficulty.difficulty_level }}</mat-option
                      >
                    }
                  </mat-select>
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Sort</mat-label>
                  <mat-select [formControl]="formFilters.controls.sort">
                    <mat-option>&mdash;</mat-option>
                    <mat-option value="name">Name</mat-option>
                    <mat-option value="due_date">Due Date</mat-option>
                    <mat-option value="period">Period Date</mat-option>
                    <mat-option value="status_date">Status Date</mat-option>
                    <mat-option value="followup_date">Followup Date</mat-option>
                  </mat-select>
                </mat-form-field>
                <button mat-raised-button color="primary" (click)="processFilters()">
                  Apply Filters
                </button>
                <button mat-raised-button (click)="clearFilters()">Clear Filters</button>
              </div>
            </div>
            <div class="pagination container">
              <button mat-raised-button (click)="openCreateModal()">
                Track Additional Document
              </button>
              <mat-paginator
      [pageSize]="
        (documentsTrackerService.documents$ | async)?.paginatorInfo?.perPage ??
        0
      "
                [hidePageSize]="true"
                [showFirstLastButtons]="true"
      [pageIndex]="
        ((documentsTrackerService.documents$ | async)?.paginatorInfo
          ?.currentPage ??
          1) -
        1
      "
                (page)="getPage($event.pageIndex + 1)"
      [length]="
        (documentsTrackerService.documents$ | async)?.paginatorInfo?.total ?? 0
      ">
              </mat-paginator>
            </div>
          </div>
          <div class="table-wrapper">
            <table mat-table [dataSource]="items$" multiTemplateDataRows>
              <ng-container matColumnDef="expand_collapse">
                <th *matHeaderCellDef mat-header-cell></th>
                <td *matCellDef="let item" mat-cell>
                  <button
                    mat-icon-button
                    (click)="item.expanded = !item.expanded"
                    class="expand-collapse"
                    [ngClass]="{ expand: item.expanded }">
                    <mat-icon>keyboard_arrow_down</mat-icon>
                  </button>
                </td>
              </ng-container>
              <ng-container matColumnDef="entity_name">
                <th *matHeaderCellDef mat-header-cell>Name</th>
                <td *matCellDef="let item" mat-cell>
                  <span class="entity">{{ item.entity_name }}</span>
                  <a class="related_entity" target="_blank" [href]="item.related_url">{{
                    item.related_name
                  }}</a>
                </td>
              </ng-container>
              <ng-container matColumnDef="asset_manager">
                <th *matHeaderCellDef mat-header-cell>AM</th>
                <td *matCellDef="let item" mat-cell>
                  @if (item.am_name) {
                    <a [href]="item.am_url">{{ item.am_name }}</a>
                  }
                  @if (!item.am_name) {
                    <span>&mdash;</span>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="period">
                <th *matHeaderCellDef mat-header-cell>Period</th>
                <td *matCellDef="let item" mat-cell>
                  {{
                  item.document.doc_date
                  ? (item.document.doc_date | date: "MM/dd/yyyy")
                  : "\u2014"
                  }}
                </td>
              </ng-container>
              <ng-container matColumnDef="difficulty">
                <th *matHeaderCellDef mat-header-cell>Difficulty</th>
                <td *matCellDef="let item" mat-cell>
                  {{ item.difficulty_level ?? "\u2014" }}
                </td>
              </ng-container>
              <ng-container matColumnDef="auditor">
                <th *matHeaderCellDef mat-header-cell>Auditor</th>
                <td *matCellDef="let item" mat-cell>
                  @if (item.auditor_url) {
                    <a [href]="item.auditor_url">{{
                      item.auditor_name
                    }}</a>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="version">
                <th *matHeaderCellDef mat-header-cell>Version</th>
                <td *matCellDef="let item" mat-cell>
                  <span class="version-cell">
                    <span>{{ item.document.current_version }}</span>
                    @if (item.permissions | permission: '_edit') {
                      <button
                        mat-icon-button
                        (click)="incrementVersion(item.document)"
                        >
                        <mat-icon>add_box</mat-icon>
                      </button>
                    }
                  </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th *matHeaderCellDef mat-header-cell>Status</th>
                <td *matCellDef="let item" mat-cell>
                  <select
                    [disabled]="!(item.permissions | permission: '_edit')"
                    [ngModel]="item.document.current_doc_status_id"
                    (change)="updateDocStatus($event, item)">
                    @for (status of item.statuses; track status) {
                      <option [value]="status.id">
                        {{ status.name }}
                      </option>
                    }
                  </select>
                </td>
              </ng-container>
              <ng-container matColumnDef="type">
                <th *matHeaderCellDef mat-header-cell>Type</th>
                <td *matCellDef="let item" mat-cell>{{ item.type }}</td>
              </ng-container>
              <ng-container matColumnDef="status_date">
                <th *matHeaderCellDef mat-header-cell>Status Date</th>
                <td *matCellDef="let item" mat-cell>
                  <input
                    [disabled]="!(item.permissions | permission: '_edit')"
                    type="date"
                    [class]="{ empty: !item.document.current_status_date }"
                    [value]="item.document.current_status_date"
          (change)="
            rowChange.next({event:$event, document:item.document, key:'current_status_date'})
          " />
                </td>
              </ng-container>
              <ng-container matColumnDef="user">
                <th *matHeaderCellDef mat-header-cell>Last User Upd.</th>
                <td *matCellDef="let item" mat-cell>
                  {{ item.document.user?.person?.name ?? "System" }}
                </td>
              </ng-container>
              <ng-container matColumnDef="due_date">
                <th *matHeaderCellDef mat-header-cell>Due</th>
                <td *matCellDef="let item" mat-cell>
                  <input
                    type="date"
                    [class]="{ empty: !item.due_date }"
                    [disabled]="!(item.permissions | permission: '_edit')"
                    [value]="item.due_date"
                    (change)="dueDateChange.next({event:$event, document:item.document})" />
                </td>
              </ng-container>
              <ng-container matColumnDef="followup_date">
                <th *matHeaderCellDef mat-header-cell>Followup Date</th>
                <td *matCellDef="let item" mat-cell>
                  <input
                    type="date"
                    [disabled]="!(item.permissions | permission: '_edit')"
                    [class]="{ empty: !item.last_followup_sent }"
                    [value]="item.last_followup_sent"
          (change)="
            rowChange.next({event:$event, document:item.document, key:'last_followup_sent'})
          " />
                </td>
              </ng-container>
              <ng-container matColumnDef="expected_date">
                <th *matHeaderCellDef mat-header-cell>Expected Date</th>
                <td *matCellDef="let item" mat-cell>
                  <input
                    type="date"
                    [disabled]="!(item.permissions | permission: '_edit')"
                    [class]="{ empty: !item.expected_date }"
                    [value]="item.expected_date"
                    (change)="rowChange.next({event:$event, document:item.document, key:'expected_date'})" />
                </td>
              </ng-container>
              <ng-container matColumnDef="assess_fees">
                <th *matHeaderCellDef mat-header-cell>Fees</th>
                <td *matCellDef="let item" mat-cell>
                  <input
                    type="checkbox"
                    [disabled]="!(item.permissions | permission: '_edit')"
                    [checked]="item.assess_fees"
                    (change)="checkChecked($event, item)" />
                </td>
              </ng-container>
              <ng-container matColumnDef="notes">
                <th *matHeaderCellDef mat-header-cell>Notes</th>
                <td *matCellDef="let item" mat-cell>
                  <span class="notes-fields">
                    @if (!item.addingNote && item.note_text) {
                      <span>{{
                        item.note_text
                      }}</span>
                    }
                    @if (!item.addingNote && !item.note_text) {
                      <span>&mdash;</span>
                    }
                    @if (item.addingNote) {
                      <span>
                        <textarea [(ngModel)]="item.newNoteText"></textarea>
                      </span>
                    }
                    @if (!item.addingNote) {
                      <button
                        mat-icon-button
                        (click)="item.addingNote = true">
                        <mat-icon>add</mat-icon>
                      </button>
                    }
                    @if (item.addingNote) {
                      <button
                        mat-icon-button
                        (click)="saveNewNote(item)">
                        <mat-icon>save</mat-icon>
                      </button>
                    }
                  </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="expanded">
                <th *matHeaderCellDef mat-header-cell></th>
                <td
                  *matCellDef="let item"
                  mat-cell
                  [class]="{ expand: item.expanded }"
                  colspan="17">
                  @if (item.expanded) {
                    <document-versions
                      [documentId]="item.document.id"
                      [docTypeId]="item.document.doc_type_id"
                      [document]="item.document"
                      [permission]="item.permissions"
                    ></document-versions>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="delete">
                <th *matHeaderCellDef mat-header-cell></th>
                <td *matCellDef="let item" mat-cell>
                  @if (item.permissions | permission: '_delete') {
                    <button
                      mat-icon-button
                      color="warn"
                      (click)="deleteDocument(item.document)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  }
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="columns"></tr>
              <tr mat-row *matRowDef="let row; columns: columns" class="main-row"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: ['expanded']"
              class="expand-row"></tr>
            </table>
          </div>
